// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************

export enum Status {
  STATUS_NOT_SPECIFIED = 0,
  STATUS_NEW = 1,
  STATUS_OPEN = 2,
  STATUS_PENDING = 3,
  STATUS_HOLD = 4,
  STATUS_SOLVED = 5,
  STATUS_CLOSED = 6,
}

export enum SortBy {
  SORT_BY_NOT_SPECIFIED = 0,
  SORT_BY_UPDATED_AT = 1,
  SORT_BY_CREATED_AT = 2,
  SORT_BY_PRIORITY = 3,
  SORT_BY_STATUS = 4,
  SORT_BY_TICKET_TYPE = 5,
}

export enum SortOrder {
  SORT_ORDER_NOT_SPECIFIED = 0,
  SORT_ORDER_ASC = 1,
  SORT_ORDER_DESC = 2,
}
